/* =========================================================================
   Volition landing behaviour — ported from volition-landing.src.html.

   Two deliberate changes from the source script:
   1. Every lookup is guarded. In the source every element was guaranteed to
      exist; here a merchant can remove or reorder any section in the theme
      editor, and one missing node must not kill the rest of the page.
   2. The countdown target comes from a data attribute instead of a hardcoded
      date, so it is editable without a code change.
   ========================================================================= */
(function () {
  'use strict';

  function init() {
    stickyHeader();
    mobileNav();
    reveal();
    countdown();
  }

  // Header flips to its solid state once the hero is mostly scrolled past.
  function stickyHeader() {
    var hd = document.getElementById('hd');
    if (!hd) return;
    function onScroll() {
      hd.classList.toggle('solid', window.scrollY > window.innerHeight * 0.72);
    }
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
  }

  function mobileNav() {
    var mnav = document.getElementById('mnav');
    if (!mnav) return;
    var burger = document.getElementById('burger');
    var close = document.getElementById('mx');

    function open() {
      mnav.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function shut() {
      mnav.classList.remove('open');
      document.body.style.overflow = '';
    }

    if (burger) burger.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    mnav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', shut);
    });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mnav.classList.contains('open')) shut();
    });
  }

  function reveal() {
    var els = document.querySelectorAll('[data-rv]');
    if (!els.length) return;
    // Without IntersectionObserver, show everything rather than hide it.
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function countdown() {
    var cd = document.getElementById('cd');
    if (!cd) return;
    var parts = {
      d: cd.querySelector('[data-d]'),
      h: cd.querySelector('[data-h]'),
      m: cd.querySelector('[data-m]'),
      s: cd.querySelector('[data-s]')
    };

    var target = Date.parse(cd.getAttribute('data-target') || '');
    if (isNaN(target)) return;

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function tick() {
      var left = Math.max(0, target - Date.now());
      var set = {
        d: Math.floor(left / 864e5),
        h: Math.floor((left % 864e5) / 36e5),
        m: Math.floor((left % 36e5) / 6e4),
        s: Math.floor((left % 6e4) / 1e3)
      };
      Object.keys(parts).forEach(function (k) {
        if (parts[k]) parts[k].textContent = pad(set[k]);
      });
      if (left === 0) clearInterval(timer);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
